module.exports = __webpack_public_path__ + "img/faro-beach.d103d3a5.jpg";